// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xBMP","tabsBox":"styles_tabsBox__3J1vK","createButton":"styles_createButton__10biJ"};